<template>
  <div class="modal fade text-center" id="creating-order" tabindex="-1" role="dialog"
       aria-labelledby="myModalLabel" backdrop="static" keyboard="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <template v-if="!!createOrderError">
          <modal-header></modal-header>
        </template>

        <div class="modal-body">
          <template v-if="createOrderError === ''">
            <spinner :show="creatingOrder || creatingSubscription" class="spinner-component"></spinner>
            <p>{{ $t('creatingOrder') }}</p>
          </template>
          <p class="error-message">{{ createOrderError }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import Spinner from '../Spinner.vue'
  import ModalHeader from '../modalHeader/ModalHeader.vue'
  import $ from 'jquery'

  export default {
    name: 'creating-order',
    components: {Spinner, ModalHeader},
    data: function () {
      return {
        creatingOrder: true,
        creatingSubscription: true,
        createOrderError: ''
      }
    },
    locales,
    watch: {
      creatingOrder() {
        if (!this.creatingOrder) {
          $('#creating-order').modal('hide')
          $('#created-order').modal('show')
          this.creatingOrder = true
        }
      },
      creatingSubscription() {
        if (!this.creatingSubscription) {
          $('#creating-order').modal('hide')
          $('#created-subscription').modal('show')
          this.creatingSubscription = true
        }
      },
      createOrderError() {
        window.localStorage.removeItem('errorMessage')
      }
    },
    mounted() {
      $('#creating-order').modal({
        show: false,
        backdrop: 'static'
      })
      window.onstorage = (e) => {
        if (e.newValue) {
          switch (e.key) {
            case 'orderNumber': {
              this.$store.commit('setOrderNumber', window.localStorage.getItem('orderNumber'))
              setTimeout(() => {
                this.creatingOrder = false
              }, 2000)
              break
            }
            case 'subscriptionId': {
              this.$store.commit('setSubscriptionId', window.localStorage.getItem('subscriptionId'))
              setTimeout(() => {
                this.creatingSubscription = false
              }, 2000)
              break
            }
            case 'errorMessage': {
              this.createOrderError = window.localStorage.getItem('errorMessage')
              break
            }
            case 'closeWindow': {
              if (window.localStorage.getItem('closeWindow') && !this.createOrderError) {
                this.createOrderError = this.$t('createOrderError')
              }
              break
            }
          }
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  @import "../../assets/scss/reset-modal";

  .modal-dialog {
    @include modal-dialog($height: 3.72rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.86rem) 0 0 -45% !important;
    }
  }

  .modal-body {
    padding: .5rem 0 .8rem 0;
    .spinner-component {
      margin: .4rem auto;
    }
    p {
      line-height: .3rem;
      font-size: .14rem;
      &.error-message {
        margin-top: .6rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CreatingOrder.vue?d969a9c4